import { Deserializable } from '../../protocols/deserializable';

export class ContactInfo implements Deserializable {
  primaryPhoneNumberCountryCode: string | null = null;
  primaryPhoneNumber: string | null = null;
  secondaryPhoneNumberCountryCode: string | null = null;
  secondaryPhoneNumber: string | null = null;

  onDeserialize(): void {}
}
